import {inject, Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Observable} from 'rxjs';
import {CompanyControllerService, CompanyResponse} from '@frontend/shared-api';

@Injectable({providedIn: 'root'})
export class CompaniesResolver implements Resolve<CompanyResponse[]> {
  private readonly companyController = inject(CompanyControllerService);
  resolve(): Observable<CompanyResponse[]> {
    return this.companyController.getAllCompanies();
  }
}
